'use strict';

var platform = require('platform');

/*@ngInject*/
module.exports = function($window) {
	return platform;
};